import React, { forwardRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const isRecaptchaConfigured = Boolean(RECAPTCHA_SITE_KEY);

// reCAPTCHA v2 tokens are single-use: once verified server-side, the same
// token is rejected as "duplicate" on a second submit. Forwarding the ref
// lets callers reset() the widget after a failed submit so the user gets a
// fresh token for their next attempt.
const RecaptchaField = forwardRef(({ onChange }, ref) => {
  if (!isRecaptchaConfigured) {
    return null;
  }

  return (
    <div className="mb-3">
      <ReCAPTCHA ref={ref} sitekey={RECAPTCHA_SITE_KEY} onChange={onChange} />
    </div>
  );
});

export default RecaptchaField;
